import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0B0F1A] border-t border-[rgba(247,245,240,0.06)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <button onClick={() => scrollTo('hero')} className="cursor-pointer">
          <img
            src="https://static.readdy.ai/image/342255b0bb01b37d074e93c86c4d5fe5/5dac46d95f2dd311368d9a0b4d745fe3.svg"
            alt="Alice & Bob Capital"
            className="h-6 w-auto opacity-60"
          />
        </button>

        {/* Nav links */}
        <nav className="hidden sm:flex items-center gap-6">
          {[
            { labelKey: 'nav_services', id: 'servicios' },
            { labelKey: 'nav_portfolio', id: 'portfolio' },
            { labelKey: 'nav_about', id: 'sobre' },
            { labelKey: 'nav_contact', id: 'contacto' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="font-['DM_Sans'] text-xs text-[#6B7280] hover:text-[#F7F5F0] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {t(item.labelKey)}
            </button>
          ))}
        </nav>

        {/* Copyright */}
        <p className="font-['JetBrains_Mono'] text-xs text-[#6B7280]/60">
          {t('footer_copy')}
        </p>
      </div>
    </footer>
  );
}
